module.exports = __webpack_public_path__ + "site/img/68.e7bbb575.jpg";